import { ItemGroupUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/inventory/v1/item_group_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

type ItemGroupUpdatedDetailProps = {
  event: ItemGroupUpdatedEvent;
};

export const ItemGroupUpdatedDetail = ({
  event,
}: ItemGroupUpdatedDetailProps) => {
  const previous = event.previousItemGroup;
  const current = event.updatedItemGroup;

  if (!previous || !current) {
    return (
      <Col className="@ItemGroupUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'name',
      label: 'Name',
      previous: previous.name,
      current: current.name,
    },
    {
      field: 'number',
      label: 'Number',
      previous: previous.number,
      current: current.number,
    },
    {
      field: 'description',
      label: 'Description',
      previous: previous.description,
      current: current.description,
    },
    {
      field: 'notes',
      label: 'Notes',
      previous: previous.notes,
      current: current.notes,
    },
    {
      field: 'parentId',
      label: 'Parent ID',
      previous: previous.parentId?.value,
      current: current.parentId?.value,
    },
  ];

  return (
    <Col className="@ItemGroupUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Item Group</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay label="Name" value={current.name} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
